import type { Transition } from "@uirouter/core";

import { getUrlComponents } from "pro-features/components/AutocompleteWebsites/urlComponentUtils";
import type { IChosenItemParams } from "app/components/compare/WebsiteQueryBar/WebsitePageQueryBarUtils";

export const onEnterPageAnalysis = (transition: Transition) => {
    const toParams = transition.params();
    const toState = transition.to().name;
    const { key = "", pageFilter = "", didReplacePageParam = false } = toParams;

    if (didReplacePageParam) {
        return;
    }

    const keyArr: string[] = key.length ? key.split(",") : [];
    const pageArr: IChosenItemParams = pageFilter ? JSON.parse(pageFilter) : [];
    const missingKeys = keyArr.filter((key) => !pageArr.some((p) => p.url.startsWith(key)));

    const missingPages: IChosenItemParams = missingKeys.map((key) => {
        const { subdomain } = getUrlComponents(key);
        return {
            url: key,
            searchType: subdomain ? "subdomain" : "domain",
        };
    });

    if (key?.length && missingPages.length) {
        const newPageFilter = JSON.stringify([...pageArr, ...missingPages]);
        const hasComeFromSameState = transition.from()?.name?.length && transition.from().name === toState;

        return transition.router.stateService.target(
            toState,
            {
                ...toParams,
                pageFilter: newPageFilter,
                didReplacePageParam: true,
            },
            hasComeFromSameState ? { location: "replace" } : {},
        );
    }
};
